/* Native images load without this enhancement. Only their source-size hint is
 * refined here, preserving object-fit quality and economical source selection
 * on browsers without sizes="auto". Never gate src, srcset or visibility on JS.
 */
(function () {
  'use strict';
  if (window.AvalyResponsiveImages) return;

  var selector = 'img[data-avaly-responsive-image]';
  var observed = new Set();
  var pending = new Set();
  var frame = 0;
  var started = false;
  var resizeObserver;
  var mutationObserver;

  function number(value) {
    var result = parseFloat(value);
    return isFinite(result) ? result : 0;
  }

  function forget(image) {
    pending.delete(image);
    observed.delete(image);
    if (resizeObserver) resizeObserver.unobserve(image);
  }

  function measure(image) {
    if (!image.isConnected) { forget(image); return; }
    var style = window.getComputedStyle(image);
    var width = image.clientWidth - number(style.paddingLeft) - number(style.paddingRight);
    var height = image.clientHeight - number(style.paddingTop) - number(style.paddingBottom);
    // A hidden carousel/variant must retain its usable native fallback. Its
    // ResizeObserver or ancestor mutation schedules another measurement.
    if (width <= 0 || height <= 0) return;

    var ratio = number(image.getAttribute('data-avaly-image-ratio'));
    var slot = width;
    if (ratio > 0) {
      if (style.objectFit === 'cover') slot = Math.max(width, height * ratio);
      if (style.objectFit === 'contain') slot = Math.min(width, height * ratio);
      if (style.objectFit === 'scale-down') {
        var naturalWidth = number(image.getAttribute('width'));
        slot = Math.min(width, height * ratio, naturalWidth > 0 ? naturalWidth : width);
      }
      if (style.objectFit === 'none') slot = number(image.getAttribute('width')) || width;
    }
    // sizes is in CSS pixels. The browser, not this helper, applies screen DPR.
    var sizes = Math.max(1, Math.ceil(slot)) + 'px';
    if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
  }

  function flush() {
    frame = 0;
    var images = Array.from(pending);
    pending.clear();
    images.forEach(measure);
  }

  function queue(image) {
    pending.add(image);
    if (!frame) {
      frame = window.requestAnimationFrame ? window.requestAnimationFrame(flush) : window.setTimeout(flush, 16);
    }
  }

  function eachImage(root, callback) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function register(root) {
    eachImage(root || document, function (image) {
      if (!observed.has(image)) {
        observed.add(image);
        if (resizeObserver) resizeObserver.observe(image);
      }
      queue(image);
    });
  }

  function start() {
    if (started) return;
    started = true;
    if (window.ResizeObserver) {
      resizeObserver = new window.ResizeObserver(function (entries) {
        entries.forEach(function (entry) { queue(entry.target); });
      });
      observed.forEach(function (image) { resizeObserver.observe(image); });
    }
    register(document);
    if (window.MutationObserver) {
      mutationObserver = new window.MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'attributes') {
            register(record.target);
          } else {
            record.removedNodes.forEach(function (node) {
              eachImage(node, function (image) { if (!image.isConnected) forget(image); });
            });
            record.addedNodes.forEach(register);
          }
        });
      });
      // Deliberately exclude sizes/src attributes to avoid self-triggered loops.
      mutationObserver.observe(document.documentElement, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }
    window.addEventListener('resize', function () { observed.forEach(queue); }, {passive: true});
    document.addEventListener('shopify:section:load', function (event) { register(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { eachImage(event.target, forget); });
  }

  window.AvalyResponsiveImages = {refresh: register};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
